import {Dispatch} from "redux";
import {
  APP_API_ERROR_RESET,
  APP_API_ERROR_SET,
  APP_FIREBASE_REMOTE_CONFIG_FETCH_START,
  APP_FIREBASE_REMOTE_CONFIG_FETCH_SUCCESS,
  APP_SET_PATHNAME,
} from "../constants/app";
import {ErrorDto} from "../models/dtos/error.dto";
import FirebaseService from "../services/firebase.service";
import {
  ApiErrorResetAction,
  ApiErrorSetAction,
  FirebaseRemoteConfigFetchStartAction,
  FirebaseRemoteConfigFetchSuccessAction,
  SetPathnameAction,
} from "../types/app";

/**
 * FIREBASE
 */
const firebaseRemoteConfigFetchStartAction = (): FirebaseRemoteConfigFetchStartAction => {
  return {
    type: APP_FIREBASE_REMOTE_CONFIG_FETCH_START,
  }
}
const firebaseRemoteConfigFetchSuccessAction = (): FirebaseRemoteConfigFetchSuccessAction => {
  return {
    type: APP_FIREBASE_REMOTE_CONFIG_FETCH_SUCCESS,
  }
}
export const appFetchAndActivateRemoteConfig = () => async (
  dispatch: Dispatch
) => {
  try {
    dispatch(firebaseRemoteConfigFetchStartAction());
    await FirebaseService.fetchAndActivateRemoteConfig();
    dispatch(firebaseRemoteConfigFetchSuccessAction());
  } catch (error) {
    dispatch(firebaseRemoteConfigFetchSuccessAction());
  }
};

/**
 * PATHNAME
 */
const setPathnameAction = (payload: string): SetPathnameAction => {
  return {
    type: APP_SET_PATHNAME,
    payload: payload,
  }
}
export const appSetPathname = (pathname: string) => (
  dispatch: Dispatch
) => {
  dispatch(setPathnameAction(pathname));
}

/**
 * API_ERROR
 */
const apiErrorSetAction = (payload: ErrorDto): ApiErrorSetAction => {
  return {
    type: APP_API_ERROR_SET,
    payload: payload,
  }
}
export const appSetApiError = (errorDto: ErrorDto) => (
  dispatch: Dispatch
) => {
  dispatch(apiErrorSetAction(errorDto));
}

const apiErrorResetAction = (): ApiErrorResetAction => {
  return {
    type: APP_API_ERROR_RESET,
  }
}
export const appResetApiError = () => (
  dispatch: Dispatch
) => {
  dispatch(apiErrorResetAction());
}
